import { exitVent } from './vents.js';
/** The deadline id the room fires when the drivers have lasted. */
export const HIDE_DEADLINE = 'hide.end';
/** The clock settings (the schema requires them in this mode; the preset's are the fallback). */
const DEFAULTS = {
    survivalMs: 180_000,
    stopCutMs: 10_000,
    headStartMs: 10_000,
    escapes: 2,
    escapeMs: 5_000,
    finalMs: 45_000,
    finalVision: 1.6,
    finalSpeed: 1.2,
};
export const hideConfig = (s) => s.config.hide ?? DEFAULTS;
export function createHide(s) {
    const c = hideConfig(s);
    const h = { startedAt: s.now, endsAt: s.now + c.survivalMs, escapes: {}, escapeEndsAt: {} };
    for (const id of s.order) {
        const p = s.players[id];
        h.escapes[id] = p.role === 'crew' ? c.escapes : 0;
        h.escapeEndsAt[id] = 0;
        // the agbero is not on the route: no stops to fake
        if (p.role === 'impostor')
            s.tasks[id] = [];
    }
    return h;
}
/** Has the agbero been let go yet? (Before this, the agbero's keke stands still.) */
export const seeking = (s) => !s.hide || s.now >= s.hide.startedAt + hideConfig(s).headStartMs;
/** In the final stretch of the clock. */
export const finalStretch = (s) => Boolean(s.hide) && s.now >= s.hide.endsAt - hideConfig(s).finalMs;
/** A stop done by a living driver pulls the clock closer (never below now). */
export function cutClock(s, p) {
    const h = s.hide;
    if (!h || p.role !== 'crew' || !p.alive)
        return;
    h.endsAt = Math.max(s.now, h.endsAt - hideConfig(s).stopCutMs);
    s.deadlines[HIDE_DEADLINE] = h.endsAt;
}
/** Why this keke may not use a shortcut now, or null. Only drivers escape; entering spends an escape. */
export function mayEscape(s, p, action) {
    if (p.role !== 'crew')
        return 'NOT_IN_MODE';
    if (action !== 'enter')
        return null;
    return (s.hide?.escapes[p.id] ?? 0) > 0 ? null : 'NO_ESCAPES';
}
export function spendEscape(s, p) {
    const h = s.hide;
    if (!h || p.role !== 'crew')
        return;
    h.escapes[p.id] = Math.max(0, (h.escapes[p.id] ?? 0) - 1);
    h.escapeEndsAt[p.id] = s.now + hideConfig(s).escapeMs;
}
/** Each tick: a driver whose escape has run out is pushed out of the shortcut. */
export function tickHide(s, events) {
    const h = s.hide;
    if (!h)
        return;
    for (const id of s.order) {
        const p = s.players[id];
        if (p.vent !== null && p.role === 'crew' && s.now >= (h.escapeEndsAt[id] ?? 0))
            exitVent(s, p, events);
    }
}
//# sourceMappingURL=hide.js.map